AnalyticsWebClient  = require '@atlassiansox/analytics-web-client'
AnalyticsWebClientConstructor = AnalyticsWebClient.default
Auth = require 'db/auth'
Browser = require 'lib/browser'
ClientConfig = require 'debug/client-config'
EMAUEmbedWhitelist = require 'data/emau-embed-whitelist'
{ getQueryParameter } = require 'lib/util'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'

if ClientConfig.get('appId') == 'desktop'
  origin = AnalyticsWebClient.originType.DESKTOP
  platform = switch ClientConfig.get('analyticsContext')?.platform
    when 'darwin'
      AnalyticsWebClient.platformType.MAC
    when 'win32'
      AnalyticsWebClient.platformType.WINDOWS
    else # in the case where the analyticsContext is not defined, use null
      null
else
  origin = AnalyticsWebClient.originType.WEB

analyticsClient = new AnalyticsWebClientConstructor
  env: AnalyticsWebClient.envType[window.analyticsWebClientEnv]
  product: 'trello',
  version: window.clientVersion
  origin: origin
  platform: platform

window.sp? 'newTracker', 'cf', window.snowplowCloudfrontServer,
  appId: ClientConfig.get('appId') or 'web'
  cookieDomain: '.trello.com'
  respectDoNotTrack: true

if Auth.isLoggedIn()
  window.sp?('setUserId:cf', Auth.myId())
  trackGoogleTagManager.push isLoggedIn: true
else
  trackGoogleTagManager.push isLoggedIn: false

emauEmbeddable = getQueryParameter('iframeSource', '') in EMAUEmbedWhitelist

if Auth.isLoggedIn() && (!Browser.isEmbeddedDocument() || emauEmbeddable)
  analyticsClient.setTenantInfo AnalyticsWebClient.tenantType.NONE
  analyticsClient.setUserInfo AnalyticsWebClient.userType.TRELLO, Auth.myId()
  analyticsClient.startUIViewedEvent()


window.dataLayer?.push inApp: true
window.sp? ->
  trackGoogleTagManager.push
    event: 'snowplow.loaded'
    snowplow:
      domain_userid: this.cf?.getDomainUserId()



// WEBPACK FOOTER //
// ./app/scripts/init/init-analytics.coffee